import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import ResourcesPage from './components/ResourcesPage';
import SplashScreen from './components/SplashScreen';
import ChatBot from './components/ChatBot';

function App() {
  return (
    <Router>
      <div style={{ fontFamily: "'Nunito', sans-serif" }}>
        <Routes>
          {/* Public Routes - No Navigation */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          
          {/* Old Splash Screen Route - keeping for compatibility */}
          <Route path="/splash" element={<SplashScreen />} />
          
          {/* Password Protected Dashboard Routes */}
          <Route path="/dashboard/*" element={<><Navigation /><Dashboard /></>} />
        </Routes>
        {/* ChatBot appears on all pages */}
        <ChatBot />
      </div>
    </Router>
  );
}

export default App;